<template>
  <div>
    <div>
      <v-breadcrumbs
        class="px-0"
        :items="[
          { title: '園日誌', href: '/school-diary', color: 'primary' },
          { title: '園日誌 作成' },
        ]"
      ></v-breadcrumbs>
    </div>
    <div class="mb-8">
      <h1>園日誌 作成</h1>
    </div>

    <v-row>
      <v-col cols="4">
        <h4>日付</h4>
        <date-picker v-model="date"></date-picker>
      </v-col>
    </v-row>

    <div class="mt-2 mb-4" v-if="existingError">
      <div class="existing-error-message">
        {{ formattedDate }} の園日誌はすでに存在しています。
        <a class="ml-4" :href="`/school-diary/edit/${date}`">編集ページへ</a>
      </div>
    </div>

    <v-row>
      <v-col cols="6">
        <h4>自由記録</h4>
        <v-textarea variant="outlined" v-model="comment"></v-textarea>
      </v-col>
      <v-col cols="6">
        <h4>園行事 / 来訪者</h4>
        <v-textarea variant="outlined" v-model="event"></v-textarea>
      </v-col>
      <v-col cols="6">
        <h4>早退者 (理由)</h4>
        <v-textarea variant="outlined" v-model="earlyLeaver"></v-textarea>
      </v-col>
    </v-row>

    <div>
      <v-progress-linear
        v-if="isFetching"
        indeterminate
        color="primary"
        class="my-8"
      ></v-progress-linear>
    </div>

    <v-row>
      <v-spacer></v-spacer>
      <v-select
        variant="outlined"
        label="申請者"
        :items="staffOptions"
        item-value="userId"
        item-title="name"
        v-model="appliedBy"
      ></v-select>
      <v-spacer></v-spacer>
    </v-row>

    <div class="d-flex pa-4">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        variant="outlined"
        x-large
        :disabled="isFetching || existingError"
        class="mx-2"
        @click="createAsDraft"
        >下書きとして保存</v-btn
      >
      <v-btn
        color="primary"
        variant="flat"
        x-large
        :disabled="isFetching || existingError || !appliedBy"
        class="mx-2"
        @click="createAndApply"
        >保存して申請</v-btn
      >
      <v-spacer></v-spacer>
    </div>
  </div>
</template>
<script lang="ts">
import dayjs from "dayjs";
import { defineComponent } from "vue";
import ApiNurseryRepot from "@/api/ApiNurseryReport";

import DatePicker from "@/components/atoms/DatePicker.vue";
import LocalDataService from "@/service/LocalDataService";
import { nurseryUserModule } from "@/store/dataModules/nurseryUserModule";

interface DataType {
  date: string;
  comment: string;
  event: string;
  earlyLeaver: string;
  appliedBy: number | null;

  isFetching: boolean;
  existingError: boolean;
}

// "comment": "string",
// "event": "string",
// "earlyLeaver": "string",
// "status": "draft"

export default defineComponent({
  components: {
    DatePicker,
  },

  data: (): DataType => {
    return {
      date: dayjs().format("YYYY-MM-DD"),
      comment: "",
      event: "",
      earlyLeaver: "",
      appliedBy: null,

      isFetching: false,

      existingError: false,
    };
  },

  computed: {
    formattedDate() {
      return dayjs(this.date).format("YYYY年MM月DD日");
    },
    staffOptions() {
      return nurseryUserModule.staffs.filter(s => !s.isHidden).map((staff) => {
        return {
          userId: staff.userId,
          name: `${staff.lastName} ${staff.firstName}`,
        };
      });
    },
  },

  /*
  watch: {
    date: {
      handler() {
        this.checkExsitance();
        nurseryUserModule.listStaffs({ date: this.date });
      },
      immediate: true,
    },
  },
  */

  methods: {
    async createAsDraft() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        this.isFetching = true;
        const response = await ApiNurseryRepot.createSchoolDiary({
          date: this.date,
          nurseryId,
          comment: this.comment,
          event: this.event,
          earlyLeaver: this.earlyLeaver,
          status: "draft",
        });
        if (response) {
          this.$router.go(-1);
        }
        this.isFetching = false;
      }
    },
    async createAndApply() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId && this.appliedBy) {
        this.isFetching = true;
        const response = await ApiNurseryRepot.createSchoolDiary({
          date: this.date,
          nurseryId,
          comment: this.comment,
          event: this.event,
          earlyLeaver: this.earlyLeaver,
          appliedBy: this.appliedBy,
          status: "applied",
        });
        if (response) {
          this.$router.go(-1);
        }
        this.isFetching = false;
      }
    },
    async checkExsitance() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiNurseryRepot.getNurseryReport({
          nurseryId,
          date: this.date,
        });
        if (response) {
          this.existingError = true;
        } else {
          this.existingError = false;
        }
      }
    },
  },

  async mounted() {
    const nurseryId = LocalDataService.getNurseryId();
    if (nurseryId) {
      nurseryUserModule.listStaffs({ date: this.date });
    }
  },
});
</script>
<style scoped>
.existing-error-message {
  font-weight: bold;
  color: #e53935;
}
</style>
